module.exports = __webpack_public_path__ + "static/fundo-empresa-baa529316b2e2f5a2048ce6c471122ab.jpg";